import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

// import { MindARThree } from 'mind-ar/dist/mindar-image-three.prod.js'
// import { MindARThree } from "../../src/face-target/three.js";
import { MindARThree } from "mind-ar/dist/mindar-face-three.prod.js";

class ThreeJSModule {
  constructor(data) {
    this.mindarThree = new MindARThree({
      container: data.container,
      uiError: "no",
      uiLoading: "no",
      uiScanning: "no",
      maxTrack: 4,
      numFaces: 2,
      showVideo: false,
    });

    this.renderer = this.mindarThree.renderer;
    this.scene = this.mindarThree.scene;
    this.camera = this.mindarThree.camera;
    this.faceMesh = null;
    this.targetIndex = 2;

    console.dir(this.mindarThree);
    this.init();
  }

  init() {
    // create the image looper
    this.images = [
      {
        map: "./assets/images/pics/1955-bob_bill-colorized.jpg",
        depthMap: "./assets/images/pics/1955-bob_bill-depthmap.jpg",
      },
      {
        map: "./assets/images/pics/1955-granny_bill-colorized.jpg",
        depthMap: "./assets/images/pics/1955-granny_bill-depthmap.jpg",
      },
      {
        map: "./assets/images/pics/1959-bill_craig_mike-colorized-final.jpg",
        depthMap:
          "./assets/images/pics/1959-bill_craig_mike-colorized-depthmap.jpg",
        depth: 1,
      },
      // {
      //   map: "./assets/images/pics/1969-bill-freshman.jpg",
      //   depthMap: "./assets/images/pics/1969-bill-freshman-depthmap.PNG",
      // },
      {
        map: "./assets/images/pics/1976-amberg-bill-trench.jpg",
        depthMap: "./assets/images/pics/1976-amberg-bill-trench-depthmap.PNG",
      },
      {
        map: "./assets/images/pics/1976-barb_bill.jpg",
        depthMap: "./assets/images/pics/1976-barb_bill-depthmap.PNG",
      },
    ];

    this.faceMesh = this.mindarThree.addFaceMesh();

    // setup lights
    const light = new THREE.HemisphereLight(0x000000, 0xffffff, 0.5);
    this.scene.add(light);

    // define these variables outside of the loop to avoid
    // reallocating memory. Instead, set the values in the loop
    this.faceMatrix = new THREE.Matrix4();
    this.headRotation = new THREE.Quaternion();

    this.targetCameraQuat = new THREE.Quaternion();
    this.targetCameraRot = new THREE.Vector3();
    this.targetCameraPos = new THREE.Vector3();

    this.CAMERA_OFFSET = new THREE.Vector3(0, 0.4, 0);
    this.CAMERA_SCALAR = new THREE.Vector3(1, 1, 1);
    this.INERTIA_SMOOTHING = 0.95;

    this.dragOffset = { x: 0, y: 0 };
    this.isDragging = false;
    this.dragLast = { x: 0, y: 0 };
    this.zoomOffset = 0;
    this.pinchLastDist = null;

    this.started = false;

    this.modelRotationOffset = new THREE.Vector3(0, 0, 0);
  }

  animate() {
    // cube.rotateZ(0.01);

    // animation update
    // const delta = this.clock.getDelta();
    // if (this.mixer && this.activeAnimation) this.mixer.update(delta);

    // SPATIAL CAMERA CODE ////////////////////////////////////////////////////////////
    // Keeping code here instead of in another function to prevent extra function depth
    //////////////////////////////////////////////////////////////////////////////////

    // set face matrix
    this.mindarThree.controller?.lastEstimateResult?.faceMatrix?.length >= 16 &&
      this.faceMatrix.set(
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[0],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[1],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[2],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[3],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[4],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[5],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[6],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[7],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[8],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[9],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[10],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[11],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[12],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[13],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[14],
        this.mindarThree.controller?.lastEstimateResult?.faceMatrix[15],
      );

    // set the target value based on the current tracker value
    // POSITION
    this.targetCameraPos.setFromMatrixPosition(this.faceMatrix);
    // linear mapping from face pos to camera pos
    this.targetCameraPos.multiplyVectors(
      this.targetCameraPos,
      this.CAMERA_SCALAR,
    );
    this.targetCameraPos.add(this.CAMERA_OFFSET);

    // now update the head quaternion based on the rotation param of the matrix
    // this.headRotation.setFromRotationMatrix(this.faceMatrix);
    // this.headRotation.normalize();

    // ROTATION
    // this.targetCameraRot.copy(this.headRotation);
    // this.targetCameraRot.multiplyScalar(0.4);

    // this.targetCameraRot.multiply(new THREE.Vector3(-1, 1, 1))
    // targetCameraQuat.set(
    //   faceMatrix.quaternion.x,
    //   faceMatrix.quaternion.y,
    //   faceMatrix.quaternion.z,
    //   faceMatrix.quaternion.w
    // );

    // output section to move the camera
    // move the camera holder to mimic the user's movement
    if (this.mindarThree.camera) {
      this.mindarThree.camera.position.set(
        this.mindarThree.camera.position.x * this.INERTIA_SMOOTHING +
          (1 - this.INERTIA_SMOOTHING) * this.targetCameraPos.x,
        this.mindarThree.camera.position.y * this.INERTIA_SMOOTHING +
          (1 - this.INERTIA_SMOOTHING) * this.targetCameraPos.y,
        this.mindarThree.camera.position.z * this.INERTIA_SMOOTHING -
          (1 - this.INERTIA_SMOOTHING) * this.targetCameraPos.z,
      );
      // compose manual drag/zoom offsets on top of face-tracked position
      this.mindarThree.camera.position.x += this.dragOffset.x;
      this.mindarThree.camera.position.y += this.dragOffset.y;
      this.mindarThree.camera.position.z += this.zoomOffset;
    }
    // if (cameraRef?.current) {
    //   cameraRef.current.position.set(
    //     -this.targetCameraPos.x,
    //     -this.targetCameraPos.y - 10,
    //     this.targetCameraPos.z
    //   );
    // }

    // for smoothing, we'll probably end up lerping between quaternions once I get my holder squared away
    // since we shouldn't have too many issues with gimble lock in this case, we can get away with our 80-20 rule
    // not ideal (A), but works, but gimble lock (B)
    // TODO: transfer to moving the render camera for this world (A)
    // TODO: convert to a quaternion transform (B)

    this.images.map((image, imageIndex) => {
      // debugger;
      // opacity fade
      /*
      image.photo.material.opacity =
        imageIndex !== targetIndex
          ? image.photo.material.opacity * 0.9
          : image.photo.material.opacity +
            (1 - image.photo.material.opacity) * 0.1;
            */

      // set the visibility to either true if it's the one or if it's fading
      image.photo.visible = imageIndex === this.targetIndex || false;
      // image.photo.material.opacity > 0.001;
    });

    // END SPATIAL CAMERA CODE ///////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////////////

    // register next update and do render
    this.animationFrame = requestAnimationFrame(this.animate.bind(this));
    this.renderer.render(this.scene, this.camera);
  }

  navigate(direction) {
    if (this.rotateInterval) {
      clearInterval(this.rotateInterval);
      this.rotateInterval = null;
    }
    const len = this.images.length;
    this.targetIndex = (this.targetIndex + direction + len) % len;
  }

  stop() {
    cancelAnimationFrame(this.animationFrame);
    clearInterval(this.rotateInterval);
    window.removeEventListener("keydown", this._onKeyDown);
    window.removeEventListener("mousedown", this._onMouseDown);
    window.removeEventListener("mousemove", this._onMouseMove);
    window.removeEventListener("mouseup", this._onMouseUp);
    window.removeEventListener("wheel", this._onWheel);
    window.removeEventListener("touchstart", this._onTouchStart);
    window.removeEventListener("touchmove", this._onTouchMove);
    window.removeEventListener("touchend", this._onTouchEnd);
    this.mindarThree.stop();
  }

  loadScene = async () => {
    this.images.map((image, imageIndex) => {
      // set the `photo` property of each image object to the Mesh object for ease of reference
      // TODO: move to a data structure
      image.photo = this.loadPhoto(imageIndex);

      // hide every photo except the target index photo, both visible (rendering speed) and alpha (fade effect)
      image.photo.visible = imageIndex === this.targetIndex;
      console.log("visible?", image.photo.visible);

      return image.photo;
    });

    // start the clock that rotates through photos
    this.rotateInterval = setInterval(() => {
      this.targetIndex = (this.targetIndex + 1) % this.images.length;
    }, 10000);

    // keyboard nav
    this._onKeyDown = (e) => {
      if (e.key === "ArrowRight") this.navigate(1);
      else if (e.key === "ArrowLeft") this.navigate(-1);
    };
    window.addEventListener("keydown", this._onKeyDown);

    const DRAG_SCALAR = 0.004;
    const container = document.getElementById("container");

    // desktop drag — click and drag to offset the virtual camera
    this._onMouseDown = (e) => {
      this.isDragging = true;
      this.dragLast = { x: e.clientX, y: e.clientY };
      if (container) container.classList.add("is-dragging");
    };
    this._onMouseMove = (e) => {
      if (!this.isDragging) return;
      this.dragOffset.x -= (e.clientX - this.dragLast.x) * DRAG_SCALAR;
      this.dragOffset.y += (e.clientY - this.dragLast.y) * DRAG_SCALAR;
      this.dragLast = { x: e.clientX, y: e.clientY };
    };
    this._onMouseUp = () => {
      this.isDragging = false;
      if (container) container.classList.remove("is-dragging");
    };
    window.addEventListener("mousedown", this._onMouseDown);
    window.addEventListener("mousemove", this._onMouseMove);
    window.addEventListener("mouseup", this._onMouseUp);

    // desktop zoom — scroll wheel adjusts camera Z, but only when resume is hidden
    const WHEEL_SCALAR = 0.003;
    this._onWheel = (e) => {
      if (container?.classList.contains("parallax-receded")) return;
      e.preventDefault();
      this.zoomOffset += e.deltaY * WHEEL_SCALAR;
    };
    window.addEventListener("wheel", this._onWheel, { passive: false });

    // mobile — touchstart seeds swipe nav and drag (1 finger) or pinch (2 fingers)
    // touchmove: 1 finger = pan, 2 fingers = pinch zoom; touchend resolves swipe nav
    const PINCH_SCALAR = 0.005;
    let touchStartX = 0;
    this._onTouchStart = (e) => {
      this.pinchLastDist = null;
      if (e.touches.length === 1) {
        touchStartX = e.touches[0].clientX;
        this.dragLast = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
    };
    this._onTouchMove = (e) => {
      if (e.touches.length === 1) {
        const t = e.touches[0];
        this.dragOffset.x -= (t.clientX - this.dragLast.x) * DRAG_SCALAR;
        this.dragOffset.y += (t.clientY - this.dragLast.y) * DRAG_SCALAR;
        this.dragLast = { x: t.clientX, y: t.clientY };
        this.pinchLastDist = null;
      } else if (e.touches.length === 2) {
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        const dist = Math.hypot(dx, dy);
        if (this.pinchLastDist !== null) {
          // spread fingers → zoom in (dist grows → zoomOffset decreases → camera moves forward)
          this.zoomOffset += (this.pinchLastDist - dist) * PINCH_SCALAR;
        }
        this.pinchLastDist = dist;
      }
    };
    this._onTouchEnd = (e) => {
      this.pinchLastDist = null;
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (e.changedTouches.length === 1 && Math.abs(dx) > 40) this.navigate(dx < 0 ? 1 : -1);
    };
    window.addEventListener("touchstart", this._onTouchStart, {
      passive: true,
    });
    window.addEventListener("touchmove", this._onTouchMove, { passive: true });
    window.addEventListener("touchend", this._onTouchEnd, { passive: true });
  };

  loadPhoto = async (imageIndex) => {
    const checkStart = () => {
      if (mapLoaded && depthMapLoaded && alphaMapLoaded && !this.started) {
        this.start();
      }
    };

    const currImage = this.images[imageIndex];
    const pictureHolder = new THREE.Object3D();
    pictureHolder.rotation.x = 0.1;
    const pictureDepth = isNaN(currImage?.depth) ? 0.5 : currImage?.depth;
    let pictureMesh,
      mapLoaded = false,
      alphaMapLoaded = false,
      depthMapLoaded = false;
    const pictureMap = new THREE.TextureLoader().load(
      currImage.map,

      // onLoad callback
      (texture) => {
        pictureMesh = new THREE.Mesh(
          texture.image?.naturalWidth >= texture?.image?.naturalHeight
            ? new THREE.PlaneGeometry(
                texture.image.naturalWidth / texture.image.naturalHeight,
                1,
                180,
                90,
              )
            : new THREE.PlaneGeometry(
                1,
                texture.image.naturalHeight / texture.image.naturalWidth,
                180,
                90,
              ),
          new THREE.MeshPhongMaterial({
            map: texture,
            alphaMap: pictureAlphaMap ? pictureAlphaMap : null,
            displacementMap: pictureDepthMap,
            displacementScale: pictureDepth,
            transparent: true,
          }),
        );
        pictureMesh.position.set(0, -5, -2);
        pictureHolder.add(pictureMesh);
        this.scene.add(pictureHolder);

        const FACE_SCALE = 40;
        pictureMesh.scale.set(FACE_SCALE, FACE_SCALE, FACE_SCALE);

        // Finally, check if we need to start
        this.images[imageIndex].photo = pictureMesh;
        mapLoaded = true;
        checkStart();
      },
    );
    pictureMap.colorSpace = THREE.SRGBColorSpace;

    const pictureDepthMap = new THREE.TextureLoader().load(
      currImage.depthMap,
      (texture) => {
        // Finally, check if we need to start
        depthMapLoaded = true;
        checkStart();
      },
    );

    let pictureAlphaMap;
    if (currImage.alphaMap) {
      pictureAlphaMap = new THREE.TextureLoader().load(
        currImage.alphaMap,
        (texture) => {
          // Finally, check if we need to start
          alphaMapLoaded = true;
          checkStart();
        },
      );
    } else {
      alphaMapLoaded = true;
      checkStart();
    }

    return pictureHolder;
  };

  async start() {
    if (!this.started) {
      this.started = true;
    } else {
      return;
    }

    await this.mindarThree.start();
    document.querySelector("#webxr-landing-page").style.opacity = 0;

    this.loadScene();

    // this.setNeedScan(true);
    this.animate();
  }
}

export default ThreeJSModule;
